import { CustomUseQueryOptions } from '../types';
import type { ApiInstance, BaseTokenConfigApiResult } from '@/libs/sdk/api';
import { BASE_TOKEN_CONFIG } from '@/client/confs/app';
import { useQuery } from '@tanstack/react-query';

// Build the base-token list from the env config (BASE_TOKEN_CONFIG contains ALL
// base tokens for the tenant — e.g. DPIN's DPS + DPN), not the backend
// get-base-token-config endpoint which only returns a single token (DPS). Using
// the full env list lets the balance multicall read every token's on-chain
// balance instead of showing 0 for the extra base token(s). Field names are
// mapped to BaseTokenConfig so find()/filter() by baseTokenAddress keep working.
// Single-base tenants have length 1 -> identical to prior 1-element behavior.
// Exported so render-hot components can read the constant directly instead of
// mounting a per-instance useQuery observer (the queryFn returns it verbatim).
export const ENV_BASE_TOKENS: BaseTokenConfigApiResult = {
  baseTokens: BASE_TOKEN_CONFIG.map(c => ({
    contrractType: 'ERC20',
    baseTokenAddress: c.address,
    baseTokenName: c.name,
    baseTokenSymbol: c.symbol,
    baseTokenDecimals: c.decimals,
  })),
};

export const useBaseTokens = (api: ApiInstance, options?: CustomUseQueryOptions<BaseTokenConfigApiResult>) => {
  const { queryKey, ...rest } = options || {};
  return useQuery({
    ...rest,
    queryKey: [queryKey, 'BaseTokens'],
    queryFn: async () => ENV_BASE_TOKENS,
  });
};
